<script setup lang="ts">
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useUiStore } from '@/stores/ui'
import { settings } from '@/content'

const ui = useUiStore()
const { consent } = storeToRefs(ui)

function loadGa() {
  const id = settings.ga_id
  if (!id || typeof document === 'undefined') return
  if (document.getElementById('ga4-src')) return
  const s = document.createElement('script')
  s.id = 'ga4-src'
  s.async = true
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
  document.head.appendChild(s)
  const w = window as unknown as { dataLayer: unknown[]; gtag?: (...a: unknown[]) => void }
  w.dataLayer = w.dataLayer || []
  function gtag(...args: unknown[]) {
    w.dataLayer.push(args)
  }
  gtag('js', new Date())
  gtag('config', id, { anonymize_ip: true })
}

function updateConsent(granted: boolean) {
  const w = window as unknown as { gtag?: (...a: unknown[]) => void; dataLayer?: unknown[] }
  const g =
    w.gtag ||
    ((...args: unknown[]) => {
      w.dataLayer = w.dataLayer || []
      w.dataLayer.push(args)
    })
  g('consent', 'update', {
    ad_storage: granted ? 'granted' : 'denied',
    ad_user_data: granted ? 'granted' : 'denied',
    ad_personalization: granted ? 'granted' : 'denied',
    analytics_storage: granted ? 'granted' : 'denied',
  })
}

function accept() {
  ui.setConsent('granted')
  updateConsent(true)
  loadGa()
}
function refuse() {
  ui.setConsent('denied')
  updateConsent(false)
}

onMounted(() => {
  ui.loadConsent()
  if (ui.consent === 'granted') {
    updateConsent(true)
    loadGa()
  }
})
</script>

<template>
  <div v-if="consent === 'unset'" class="consent" role="dialog" aria-label="Gestion des cookies">
    <div class="consent__text">
      <strong>Respect de votre vie privée</strong>
      <p>
        Nous utilisons des cookies de mesure d'audience pour améliorer votre expérience. Aucun
        cookie n'est déposé sans votre accord.
      </p>
    </div>
    <div class="consent__actions">
      <button class="btn btn--ghost" @click="refuse">Refuser</button>
      <button class="btn btn--primary" @click="accept">Accepter</button>
    </div>
  </div>
</template>

<style scoped>
.consent {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 16px;
  z-index: 120;
  max-width: 560px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 18px 20px;
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
}
.consent__text {
  flex: 1;
  min-width: 200px;
}
.consent__text p {
  margin: 6px 0 0;
  font-size: 0.85rem;
  color: var(--muted);
}
.consent__actions {
  display: flex;
  gap: 10px;
}
@media (max-width: 560px) {
  .consent {
    bottom: 80px;
  }
  .consent__actions {
    width: 100%;
  }
  .consent__actions .btn {
    flex: 1;
  }
}
</style>
